/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
	SET_DATA: 'SET_DATA',
	SET_DATA_GAME: 'SET_DATA_GAME',
    SET_DATA_EXCHANGE : 'SET_DATA_EXCHANGE',
	SET_MSG: 'SET_MESSAGE',
	SET_LOCALIZE: 'SET_LOCALIZE',
	SHOW_CLOSE: 'SHOW_CLOSE',
	TOGGLE_LOADER: 'TOGGLE_LOADER',
	TOGGLE_MODAL: 'TOGGLE_MODAL',
	TOGGLE_ERROR: 'TOGGLE_ERROR',
};
